import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Influencer from "./Influencer";

@Model()
class InfluencerAddress extends ApplicationRecord {
  static jsonapiType = "influencer_addresses";

  @Attr() address: Record<string, string>;

  @Attr() archivedAt: string;

  @Attr() defaultFlag: boolean;

  @BelongsTo() influencer: Influencer;

  @Attr() influencerId: number;
}

export default InfluencerAddress;
